import backofficeService from '@/api/backoffice.js'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('year', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getAllPayeeExpenseTotal(params) {
    return backofficeService.Api().get('year/totalExpense', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`year/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('year', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`year/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  unlockReportCards(id) {
    return backofficeService.Api().put(`year/${id}/unlock-report-cards`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`year/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

}
